var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("亲爱的会员，您好！")]),_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.ERR)+" "),_c('span',{on:{"click":_vm.GoBack}},[_vm._v("返回首页")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }